export default {
  titles: {
    pickup: 'Nouto',
    delivery: 'Toimitus',
  },
  buttons: {
    confirm: 'Vahvista',
  },
};
